import React from "react"
import PropTypes from 'prop-types'
import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"

import {
    VALIDATION_CHANGED,
    VALIDATION_CONTAINS,
    VALIDATION_EMPTY, VALIDATION_LABELS, VALIDATION_MATCHES,
    VALIDATION_NOT_EMPTY
} from "../../../../../model2/automation/lib/custom-field-validation"

import {FieldAutomationTriggerFormProps} from "../../../../render/automation-trigger-form";

const options = _.map([
    VALIDATION_CHANGED,
    VALIDATION_NOT_EMPTY,
    VALIDATION_EMPTY,
    VALIDATION_CONTAINS,
    VALIDATION_MATCHES
], value=> {
    return {
        value: value,
        label: _.get(VALIDATION_LABELS,value)
    }
})

const debug = false
// const debug = "InputTriggerForm"

export default class FieldAddress_AutomationTrigger extends React.Component<FieldAutomationTriggerFormProps,any> {

    static propTypes = {
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationTriggerFormProps) {
        super(props)

        this.state = {
            validationType  : _.get(props.config, 'validationType', VALIDATION_CHANGED),
            value           : _.get(props.config, 'value', '')
        }
    }

    onChangeValidationType = (option:any) => {
        const validationType = option.value

        this.setState({
            validationType
        }, ()=>{
            this.props.onChangeCallback({validationType})
        })
    }

    onChangeContentValue = (value:any) => {
        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state.validationType, this.state.value)

        const fieldId = this.props.field.fieldId

        const data = {[fieldId]: this.props.config.value}

        return (
            <React.Fragment>
                <div className="flex-row-left-center">
                    <div className="label w-100">Trigger when</div>
                    <SelectGenericNew className                     = "selector w-180"
                                      options                       = {options}
                                      value                         = {this.state.validationType}
                                      popoverScrollContainerClasses = "max-h-200 max-w-300"
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeValidationType}/>
                </div>
                {[VALIDATION_CONTAINS,VALIDATION_MATCHES].includes(this.state.validationType) &&
                    <div className="flex-row-left-center m-t-10">
                        <div className="label w-100"/>
                        <this.props.field.renderComponents.formElementView field    = {this.props.field}
                                                                           model    = {data}
                                                                           onChange = {this.onChangeContentValue}/>
                    </div>}
            </React.Fragment>
        )
    }

}
